/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.moderation.createBlock";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"streamer":/*#__PURE__*/ l.string({"format":"did"}),"subject":/*#__PURE__*/ l.string({"format":"did"}),"reason":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":300}))});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.jsonPayload({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"cid":/*#__PURE__*/ l.string({"format":"cid"})});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Create a block (ban) on behalf of a streamer. Requires 'ban' permission. Creates an app.bsky.graph.block record in the streamer's repository. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["Unauthorized","Forbidden","SessionNotFound"]);

export { main };

export const $lxm = $nsid;
